import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';
import { KeyChord } from 'vscode/vscode/vs/base/common/keyCodes';
import { registerAction2, Action2, MenuId, MenuRegistry } from 'vscode/vscode/vs/platform/actions/common/actions';
import { equalsIgnoreCase } from 'vscode/vscode/vs/base/common/strings';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Categories } from 'vscode/vscode/vs/platform/action/common/actionCommonCategories';
import { ThemeSettings, ThemeSettingDefaults } from 'vscode/vscode/vs/workbench/services/themes/common/workbenchThemeService';
import { IWorkbenchThemeService } from 'vscode/vscode/vs/workbench/services/themes/common/workbenchThemeService.service';
import { VIEWLET_ID } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensions';
import { IExtensionGalleryService, IExtensionManagementService } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagement.service';
import { Extensions } from 'vscode/vscode/vs/platform/theme/common/colorUtils';
import 'vscode/vscode/vs/platform/theme/common/colors/baseColors';
import 'vscode/vscode/vs/platform/theme/common/colors/chartsColors';
import 'vscode/vscode/vs/platform/theme/common/colors/editorColors';
import 'vscode/vscode/vs/platform/theme/common/colors/inputColors';
import 'vscode/vscode/vs/platform/theme/common/colors/listColors';
import 'vscode/vscode/vs/platform/theme/common/colors/menuColors';
import 'vscode/vscode/vs/platform/theme/common/colors/minimapColors';
import 'vscode/vscode/vs/platform/theme/common/colors/miscColors';
import 'vscode/vscode/vs/platform/theme/common/colors/quickpickColors';
import 'vscode/vscode/vs/platform/theme/common/colors/searchColors';
import { IEditorService } from 'vscode/vscode/vs/workbench/services/editor/common/editorService.service';
import { Color } from 'vscode/vscode/vs/base/common/color';
import { ColorScheme, isHighContrast } from 'vscode/vscode/vs/platform/theme/common/theme';
import { colorThemeSchemaId } from '../../../services/themes/common/colorThemeSchema.js';
import { isCancellationError, onUnexpectedError } from 'vscode/vscode/vs/base/common/errors';
import { IQuickInputService } from 'vscode/vscode/vs/platform/quickinput/common/quickInput.service';
import { DEFAULT_PRODUCT_ICON_THEME_ID, ProductIconThemeData } from '../../../services/themes/browser/productIconThemeData.js';
import { IPaneCompositePartService } from 'vscode/vscode/vs/workbench/services/panecomposite/browser/panecomposite.service';
import { ThrottledDelayer } from 'vscode/vscode/vs/base/common/async';
import { CancellationTokenSource } from 'vscode/vscode/vs/base/common/cancellation';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IProgressService } from 'vscode/vscode/vs/platform/progress/common/progress.service';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { registerIcon } from 'vscode/vscode/vs/platform/theme/common/iconRegistry';
import { ThemeIcon } from 'vscode/vscode/vs/base/common/themables';
import { Emitter } from 'vscode/vscode/vs/base/common/event';
import { IExtensionResourceLoaderService } from 'vscode/vscode/vs/platform/extensionResourceLoader/common/extensionResourceLoader.service';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { CommandsRegistry } from 'vscode/vscode/vs/platform/commands/common/commands';
import { ICommandService } from 'vscode/vscode/vs/platform/commands/common/commands.service';
import { FileIconThemeData } from '../../../services/themes/browser/fileIconThemeData.js';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IDialogService } from 'vscode/vscode/vs/platform/dialogs/common/dialogs.service';
import { Extensions as Extensions$1 } from 'vscode/vscode/vs/workbench/common/contributions';
import 'vscode/vscode/vs/platform/notification/common/notification';
import { INotificationService } from 'vscode/vscode/vs/platform/notification/common/notification.service';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { isWeb } from 'vscode/vscode/vs/base/common/platform';
import { ITelemetryService } from 'vscode/vscode/vs/platform/telemetry/common/telemetry.service';
import { IHostService } from 'vscode/vscode/vs/workbench/services/host/browser/host.service';
import { mainWindow } from 'vscode/vscode/vs/base/browser/window';
import { IPreferencesService } from 'vscode/vscode/vs/workbench/services/preferences/common/preferences.service';
import { Toggle } from 'vscode/vscode/vs/base/browser/ui/toggle/toggle';
import { defaultToggleStyles } from 'vscode/vscode/vs/platform/theme/browser/defaultStyles';
import { DisposableStore } from 'vscode/vscode/vs/base/common/lifecycle';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';

var DefaultThemeUpdatedNotificationContribution_1;
const _moduleId = "vs/workbench/contrib/themes/browser/themes.contribution";
const manageExtensionIcon = registerIcon('theme-selection-manage-extension', Codicon.gear, ( localizeWithPath(
    _moduleId,
    0,
    'Icon for the \'Manage\' action in the theme selection quick pick.'
)));
var ConfigureItem;
( ((function(ConfigureItem) {
    ConfigureItem["BROWSE_GALLERY"] = "marketplace";
    ConfigureItem["EXTENSIONS_VIEW"] = "extensions";
    ConfigureItem["CUSTOM_TOP_ENTRY"] = "customTopEntry";
})(ConfigureItem || (ConfigureItem = {}))));
let MarketplaceThemesPicker = class MarketplaceThemesPicker {
    constructor(getMarketplaceColorThemes, marketplaceQuery, extensionGalleryService, extensionManagementService, quickInputService, logService, progressService, paneCompositeService, dialogService) {
        this.getMarketplaceColorThemes = getMarketplaceColorThemes;
        this.marketplaceQuery = marketplaceQuery;
        this.extensionGalleryService = extensionGalleryService;
        this.extensionManagementService = extensionManagementService;
        this.quickInputService = quickInputService;
        this.logService = logService;
        this.progressService = progressService;
        this.paneCompositeService = paneCompositeService;
        this.dialogService = dialogService;
        this._marketplaceExtensions = ( (new Set()));
        this._marketplaceThemes = [];
        this._searchOngoing = false;
        this._searchError = undefined;
        this._onDidChange = ( (new Emitter()));
        this._queryDelayer = ( (new ThrottledDelayer(200)));
        this._installedExtensions = extensionManagementService.getInstalled().then(installed => {
            const result = ( (new Set()));
            for (const ext of installed) {
                result.add(ext.identifier.id);
            }
            return result;
        });
    }
    get themes() {
        return this._marketplaceThemes;
    }
    get onDidChange() {
        return this._onDidChange.event;
    }
    trigger(value) {
        if (this._tokenSource) {
            this._tokenSource.cancel();
            this._tokenSource = undefined;
        }
        this._queryDelayer.trigger(() => {
            this._tokenSource = ( (new CancellationTokenSource()));
            return this.doSearch(value, this._tokenSource.token);
        });
    }
    async doSearch(value, token) {
        this._searchOngoing = true;
        this._onDidChange.fire();
        try {
            const installedExtensions = await this._installedExtensions;
            const options = { text: `${this.marketplaceQuery} ${value}`, pageSize: 20 };
            const pager = await this.extensionGalleryService.query(options, token);
            for (let i = 0; i < pager.total && i < 1; i++) {
                if (token.isCancellationRequested) {
                    break;
                }
                const nThemes = this._marketplaceThemes.length;
                const gallery = i === 0 ? pager.firstPage : await pager.getPage(i, token);
                const promises = [];
                const promisesGalleries = [];
                for (let i = 0; i < gallery.length; i++) {
                    if (token.isCancellationRequested) {
                        break;
                    }
                    const ext = gallery[i];
                    if (!( (installedExtensions.has(ext.identifier.id))) && !( (this._marketplaceExtensions.has(ext.identifier.id)))) {
                        this._marketplaceExtensions.add(ext.identifier.id);
                        promises.push(this.getMarketplaceColorThemes(ext.publisher, ext.name, ext.version));
                        promisesGalleries.push(ext);
                    }
                }
                const allThemes = await Promise.all(promises);
                for (let i = 0; i < allThemes.length; i++) {
                    const ext = promisesGalleries[i];
                    for (const theme of allThemes[i]) {
                        this._marketplaceThemes.push({ id: theme.id, theme: theme, label: theme.label, description: `${ext.displayName} · ${ext.publisherDisplayName}`, galleryExtension: ext, buttons: [configureButton] });
                    }
                }
                if (nThemes !== this._marketplaceThemes.length) {
                    this._marketplaceThemes.sort((t1, t2) => t1.label.localeCompare(t2.label));
                    this._onDidChange.fire();
                }
            }
        }
        catch (e) {
            if (!isCancellationError(e)) {
                this.logService.error(`Error while searching for themes:`, e);
                this._searchError = 'message' in e ? e.message : String(e);
            }
        }
        finally {
            this._searchOngoing = false;
            this._onDidChange.fire();
        }
    }
    openQuickPick(value, currentTheme, selectTheme) {
        let result = undefined;
        return (
             (new Promise((s, _) => {
                const quickpick = this.quickInputService.createQuickPick();
                quickpick.items = [];
                quickpick.sortByLabel = false;
                quickpick.matchOnDescription = true;
                quickpick.buttons = [this.quickInputService.backButton];
                quickpick.title = 'Marketplace Themes';
                quickpick.placeholder = ( localizeWithPath(
                    _moduleId,
                    1,
                    "Type to Search More. Select to Install. Up/Down Keys to Preview"
                ));
                quickpick.canSelectMany = false;
                quickpick.onDidChangeValue(() => this.trigger(quickpick.value));
                quickpick.onDidAccept(async (_) => {
                    const themeItem = quickpick.selectedItems[0];
                    if (themeItem?.galleryExtension) {
                        result = 'selected';
                        quickpick.hide();
                        const success = await this.installExtension(themeItem.galleryExtension);
                        if (success) {
                            selectTheme(themeItem.theme, true);
                        }
                        else {
                            selectTheme(currentTheme, true);
                        }
                    }
                });
                quickpick.onDidTriggerItemButton(e => {
                    if (isItem(e.item)) {
                        const extensionId = e.item.theme?.extensionData?.extensionId;
                        if (extensionId) {
                            openExtensionViewlet(this.paneCompositeService, `@id:${extensionId}`);
                        }
                        else {
                            openExtensionViewlet(this.paneCompositeService, `${this.marketplaceQuery} ${quickpick.value}`);
                        }
                    }
                });
                quickpick.onDidChangeActive(themes => {
                    if (result === undefined) {
                        selectTheme(themes[0]?.theme, false);
                    }
                });
                quickpick.onDidHide(() => {
                    if (result === undefined) {
                        selectTheme(currentTheme, true);
                        result = 'cancelled';
                    }
                    quickpick.dispose();
                    s(result);
                });
                quickpick.onDidTriggerButton(e => {
                    if (e === this.quickInputService.backButton) {
                        result = 'back';
                        quickpick.hide();
                    }
                });
                this.onDidChange(() => {
                    let items = this.themes;
                    if (this._searchOngoing) {
                        items = items.concat({ label: '$(sync~spin) Searching for themes...', id: undefined, alwaysShow: true });
                    }
                    else if (items.length === 0 && this._searchError) {
                        items = [{ label: `$(error) ${( localizeWithPath(_moduleId, 2, 'Error while searching for themes: {0}', this._searchError))}`, id: undefined, alwaysShow: true }];
                    }
                    const activeItemId = quickpick.activeItems[0]?.id;
                    const newActiveItem = activeItemId ? items.find(i => isItem(i) && i.id === activeItemId) : undefined;
                    quickpick.items = items;
                    if (newActiveItem) {
                        quickpick.activeItems = [newActiveItem];
                    }
                });
                this.trigger(value);
                quickpick.show();
            }))
        );
    }
    async installExtension(galleryExtension) {
        openExtensionViewlet(this.paneCompositeService, `@id:${galleryExtension.identifier.id}`);
        const result = await this.dialogService.confirm({
            message: ( localizeWithPath(
                _moduleId,
                3,
                "This will install extension '{0}' published by '{1}'. Do you want to continue?",
                galleryExtension.displayName,
                galleryExtension.publisherDisplayName
            )),
            primaryButton: ( localizeWithPath(_moduleId, 4, "OK"))
        });
        if (!result.confirmed) {
            return false;
        }
        try {
            await this.progressService.withProgress({
                location: 15 ,
                title: ( localizeWithPath(_moduleId, 5, "Installing Extension {0}...", galleryExtension.displayName))
            }, async () => {
                await this.extensionManagementService.installFromGallery(galleryExtension, {
                    isMachineScoped: false,
                });
            });
            return true;
        }
        catch (e) {
            this.logService.error(`Problem installing extension ${galleryExtension.identifier.id}`, e);
            return false;
        }
    }
    dispose() {
        if (this._tokenSource) {
            this._tokenSource.cancel();
            this._tokenSource = undefined;
        }
        this._queryDelayer.dispose();
        this._marketplaceExtensions.clear();
        this._marketplaceThemes.length = 0;
    }
};
MarketplaceThemesPicker = ( (__decorate([
    ( (__param(2, IExtensionGalleryService))),
    ( (__param(3, IExtensionManagementService))),
    ( (__param(4, IQuickInputService))),
    ( (__param(5, ILogService))),
    ( (__param(6, IProgressService))),
    ( (__param(7, IPaneCompositePartService))),
    ( (__param(8, IDialogService)))
], MarketplaceThemesPicker)));
let InstalledThemesPicker = class InstalledThemesPicker {
    constructor(options, setTheme, getMarketplaceColorThemes, quickInputService, extensionGalleryService, paneCompositeService, extensionResourceLoaderService, instantiationService) {
        this.options = options;
        this.setTheme = setTheme;
        this.getMarketplaceColorThemes = getMarketplaceColorThemes;
        this.quickInputService = quickInputService;
        this.extensionGalleryService = extensionGalleryService;
        this.paneCompositeService = paneCompositeService;
        this.extensionResourceLoaderService = extensionResourceLoaderService;
        this.instantiationService = instantiationService;
    }
    async openQuickPick(picks, currentTheme) {
        let marketplaceThemePicker;
        if (this.extensionGalleryService.isEnabled()) {
            if (this.extensionResourceLoaderService.supportsExtensionGalleryResources && this.options.browseMessage) {
                marketplaceThemePicker = this.instantiationService.createInstance(MarketplaceThemesPicker, this.getMarketplaceColorThemes.bind(this), this.options.marketplaceTag);
                picks = [configurationEntry(this.options.browseMessage, ConfigureItem.BROWSE_GALLERY), ...picks];
            }
            else {
                picks = [...picks, { type: 'separator' }, configurationEntry(this.options.installMessage, ConfigureItem.EXTENSIONS_VIEW)];
            }
        }
        let selectThemeTimeout;
        const selectTheme = (theme, applyTheme) => {
            if (selectThemeTimeout) {
                clearTimeout(selectThemeTimeout);
            }
            selectThemeTimeout = mainWindow.setTimeout(() => {
                selectThemeTimeout = undefined;
                const newTheme = (theme ?? currentTheme);
                this.setTheme(newTheme, applyTheme ? 'auto' : 'preview').then(undefined, err => {
                    onUnexpectedError(err);
                    this.setTheme(currentTheme, undefined);
                });
            }, applyTheme ? 0 : 200);
        };
        const pickInstalledThemes = (activeItemId) => {
            return (
                 (new Promise((s, _) => {
                    let isCompleted = false;
                    const disposables = ( (new DisposableStore()));
                    const autoFocusIndex = picks.findIndex(p => isItem(p) && p.id === activeItemId);
                    const quickpick = this.quickInputService.createQuickPick();
                    quickpick.items = picks;
                    quickpick.title = this.options.title;
                    quickpick.description = this.options.description;
                    quickpick.placeholder = this.options.placeholderMessage;
                    quickpick.activeItems = [picks[autoFocusIndex]];
                    quickpick.canSelectMany = false;
                    quickpick.toggles = this.options.toggles;
                    quickpick.toggles?.forEach(toggle => {
                        toggle.onChange(() => this.options.onToggle?.(toggle, quickpick), undefined, disposables);
                    });
                    quickpick.matchOnDescription = true;
                    quickpick.onDidAccept(async (_) => {
                        isCompleted = true;
                        const theme = quickpick.selectedItems[0];
                        if (!theme || theme.configureItem) {
                            if (!theme || theme.configureItem === ConfigureItem.EXTENSIONS_VIEW) {
                                openExtensionViewlet(this.paneCompositeService, `${this.options.marketplaceTag} ${quickpick.value}`);
                            }
                            else if (theme.configureItem === ConfigureItem.BROWSE_GALLERY) {
                                if (marketplaceThemePicker) {
                                    const res = await marketplaceThemePicker.openQuickPick(quickpick.value, currentTheme, selectTheme);
                                    if (res === 'back') {
                                        await pickInstalledThemes(undefined);
                                    }
                                }
                            }
                        }
                        else {
                            selectTheme(theme.theme, true);
                        }
                        quickpick.hide();
                        s();
                    });
                    quickpick.onDidChangeActive(themes => selectTheme(themes[0]?.theme, false));
                    quickpick.onDidHide(() => {
                        if (!isCompleted) {
                            selectTheme(currentTheme, true);
                            s();
                        }
                        quickpick.dispose();
                        disposables.dispose();
                    });
                    quickpick.onDidTriggerItemButton(e => {
                        if (isItem(e.item)) {
                            const extensionId = e.item.theme?.extensionData?.extensionId;
                            if (extensionId) {
                                openExtensionViewlet(this.paneCompositeService, `@id:${extensionId}`);
                            }
                            else {
                                openExtensionViewlet(this.paneCompositeService, `${this.options.marketplaceTag} ${quickpick.value}`);
                            }
                        }
                    });
                    quickpick.show();
                }))
            );
        };
        await pickInstalledThemes(currentTheme.id);
        marketplaceThemePicker?.dispose();
    }
};
InstalledThemesPicker = ( (__decorate([
    ( (__param(3, IQuickInputService))),
    ( (__param(4, IExtensionGalleryService))),
    ( (__param(5, IPaneCompositePartService))),
    ( (__param(6, IExtensionResourceLoaderService))),
    ( (__param(7, IInstantiationService)))
], InstalledThemesPicker)));
const SelectColorThemeCommandId = 'workbench.action.selectTheme';
registerAction2(class extends Action2 {
    constructor() {
        super({
            id: SelectColorThemeCommandId,
            title: ( localize2WithPath(_moduleId, 6, 'Color Theme')),
            category: Categories.Preferences,
            f1: true,
            keybinding: {
                weight: 200 ,
                primary: KeyChord(2048  | 41 , 2048  | 50 )
            }
        });
    }
    getTitle(colorScheme) {
        switch (colorScheme) {
            case ColorScheme.DARK: return ( localizeWithPath(_moduleId, 7, "Select Color Theme for System Dark Mode"));
            case ColorScheme.LIGHT: return ( localizeWithPath(_moduleId, 8, "Select Color Theme for System Light Mode"));
            case ColorScheme.HIGH_CONTRAST_DARK: return ( localizeWithPath(_moduleId, 9, "Select Color Theme for High Contrast Dark Mode"));
            case ColorScheme.HIGH_CONTRAST_LIGHT: return ( localizeWithPath(_moduleId, 10, "Select Color Theme for High Contrast Light Mode"));
            default:
                return ( localizeWithPath(_moduleId, 11, "Select Color Theme (detect system color mode disabled)"));
        }
    }
    async run(accessor) {
        const themeService = accessor.get(IWorkbenchThemeService);
        const preferencesService = accessor.get(IPreferencesService);
        const preferredColorScheme = themeService.getPreferredColorScheme();
        let modeConfigureToggle;
        if (preferredColorScheme) {
            modeConfigureToggle = ( (new Toggle({
                title: ( localizeWithPath(_moduleId, 12, 'Detect system color mode enabled. Click to configure.')),
                icon: Codicon.colorMode,
                isChecked: false,
                ...defaultToggleStyles
            })));
        }
        else {
            modeConfigureToggle = ( (new Toggle({
                title: ( localizeWithPath(_moduleId, 13, 'Detect system color mode disabled. Click to configure.')),
                icon: Codicon.colorMode,
                isChecked: false,
                ...defaultToggleStyles
            })));
        }
        const options = {
            installMessage: ( localizeWithPath(_moduleId, 14, "Install Additional Color Themes...")),
            browseMessage: '$(plus) ' + ( localizeWithPath(_moduleId, 15, "Browse Additional Color Themes...")),
            placeholderMessage: this.getTitle(preferredColorScheme),
            marketplaceTag: 'category:themes',
            toggles: [modeConfigureToggle],
            onToggle: async (toggle, picker) => {
                picker.hide();
                await preferencesService.openSettings({ query: ThemeSettings.DETECT_COLOR_SCHEME });
            }
        };
        const setTheme = (theme, settingsTarget) => themeService.setColorTheme(theme, settingsTarget);
        const getMarketplaceColorThemes = (publisher, name, version) => themeService.getMarketplaceColorThemes(publisher, name, version);
        const instantiationService = accessor.get(IInstantiationService);
        const picker = instantiationService.createInstance(InstalledThemesPicker, options, setTheme, getMarketplaceColorThemes);
        const themes = await themeService.getColorThemes();
        const currentTheme = themeService.getColorTheme();
        const lightEntries = toEntries(themes.filter(t => t.type === ColorScheme.LIGHT), ( localizeWithPath(_moduleId, 16, "light themes")));
        const darkEntries = toEntries(themes.filter(t => t.type === ColorScheme.DARK), ( localizeWithPath(_moduleId, 17, "dark themes")));
        const hcEntries = toEntries(themes.filter(t => isHighContrast(t.type)), ( localizeWithPath(_moduleId, 18, "high contrast themes")));
        let picks;
        switch (preferredColorScheme) {
            case ColorScheme.DARK:
                picks = [...darkEntries, ...lightEntries, ...hcEntries];
                break;
            case ColorScheme.HIGH_CONTRAST_DARK:
            case ColorScheme.HIGH_CONTRAST_LIGHT:
                picks = [...hcEntries, ...lightEntries, ...darkEntries];
                break;
            case ColorScheme.LIGHT:
            default:
                picks = [...lightEntries, ...darkEntries, ...hcEntries];
                break;
        }
        await picker.openQuickPick(picks, currentTheme);
    }
});
const SelectFileIconThemeCommandId = 'workbench.action.selectIconTheme';
registerAction2(class extends Action2 {
    constructor() {
        super({
            id: SelectFileIconThemeCommandId,
            title: ( localize2WithPath(_moduleId, 19, 'File Icon Theme')),
            category: Categories.Preferences,
            f1: true
        });
    }
    async run(accessor) {
        const themeService = accessor.get(IWorkbenchThemeService);
        const options = {
            installMessage: ( localizeWithPath(_moduleId, 20, "Install Additional File Icon Themes...")),
            placeholderMessage: ( localizeWithPath(_moduleId, 21, "Select File Icon Theme (Up/Down Keys to Preview)")),
            marketplaceTag: 'tag:icon-theme'
        };
        const setTheme = (theme, settingsTarget) => themeService.setFileIconTheme(theme, settingsTarget);
        const getMarketplaceColorThemes = (publisher, name, version) => themeService.getMarketplaceFileIconThemes(publisher, name, version);
        const instantiationService = accessor.get(IInstantiationService);
        const picker = instantiationService.createInstance(InstalledThemesPicker, options, setTheme, getMarketplaceColorThemes);
        const picks = [
            { type: 'separator', label: ( localizeWithPath(_moduleId, 22, 'file icon themes')) },
            { id: '', theme: FileIconThemeData.noIconTheme, label: ( localizeWithPath(_moduleId, 23, 'None')), description: ( localizeWithPath(_moduleId, 24, 'Disable File Icons')) },
            ...toEntries(await themeService.getFileIconThemes()),
        ];
        await picker.openQuickPick(picks, themeService.getFileIconTheme());
    }
});
const SelectProductIconThemeCommandId = 'workbench.action.selectProductIconTheme';
registerAction2(class extends Action2 {
    constructor() {
        super({
            id: SelectProductIconThemeCommandId,
            title: ( localize2WithPath(_moduleId, 25, 'Product Icon Theme')),
            category: Categories.Preferences,
            f1: true
        });
    }
    async run(accessor) {
        const themeService = accessor.get(IWorkbenchThemeService);
        const options = {
            installMessage: ( localizeWithPath(_moduleId, 26, "Install Additional Product Icon Themes...")),
            browseMessage: '$(plus) ' + ( localizeWithPath(_moduleId, 27, "Browse Additional Product Icon Themes...")),
            placeholderMessage: ( localizeWithPath(_moduleId, 28, "Select Product Icon Theme (Up/Down Keys to Preview)")),
            marketplaceTag: 'tag:product-icon-theme'
        };
        const setTheme = (theme, settingsTarget) => themeService.setProductIconTheme(theme, settingsTarget);
        const getMarketplaceColorThemes = (publisher, name, version) => themeService.getMarketplaceProductIconThemes(publisher, name, version);
        const instantiationService = accessor.get(IInstantiationService);
        const picker = instantiationService.createInstance(InstalledThemesPicker, options, setTheme, getMarketplaceColorThemes);
        const picks = [
            { type: 'separator', label: ( localizeWithPath(_moduleId, 29, 'product icon themes')) },
            { id: DEFAULT_PRODUCT_ICON_THEME_ID, theme: ProductIconThemeData.defaultTheme, label: ( localizeWithPath(_moduleId, 30, 'Default')) },
            ...toEntries(await themeService.getProductIconThemes()),
        ];
        await picker.openQuickPick(picks, themeService.getProductIconTheme());
    }
});
CommandsRegistry.registerCommand('workbench.action.previewColorTheme', async function (accessor, extension, themeSettingsId) {
    const themeService = accessor.get(IWorkbenchThemeService);
    let themes = findBuiltInThemes(await themeService.getColorThemes(), extension);
    if (themes.length === 0) {
        themes = await themeService.getMarketplaceColorThemes(extension.publisher, extension.name, extension.version);
    }
    for (const theme of themes) {
        if (!themeSettingsId || theme.settingsId === themeSettingsId) {
            await themeService.setColorTheme(theme, 'preview');
            return theme.settingsId;
        }
    }
    return undefined;
});
function findBuiltInThemes(themes, extension) {
    return themes.filter(({ extensionData }) => extensionData && extensionData.extensionIsBuiltin && equalsIgnoreCase(extensionData.extensionPublisher, extension.publisher) && equalsIgnoreCase(extensionData.extensionName, extension.name));
}
function configurationEntry(label, configureItem) {
    return {
        id: undefined,
        label: label,
        alwaysShow: true,
        buttons: [configureButton],
        configureItem: configureItem
    };
}
function openExtensionViewlet(paneCompositeService, query) {
    return paneCompositeService.openPaneComposite(VIEWLET_ID, 0 , true).then(viewlet => {
        if (viewlet) {
            (viewlet?.getViewPaneContainer()).search(query);
            viewlet.focus();
        }
    });
}
function isItem(i) {
    return i['type'] !== 'separator';
}
function toEntry(theme) {
    const settingId = theme.settingsId ?? undefined;
    const item = {
        id: theme.id,
        theme: theme,
        label: theme.label,
        description: theme.description || (theme.label === settingId ? undefined : settingId),
    };
    if (theme.extensionData) {
        item.buttons = [configureButton];
    }
    return item;
}
function toEntries(themes, label) {
    const sorter = (t1, t2) => t1.label.localeCompare(t2.label);
    const entries = ( (themes.map(toEntry))).sort(sorter);
    if (entries.length > 0 && label) {
        entries.unshift({ type: 'separator', label });
    }
    return entries;
}
const configureButton = {
    iconClass: ThemeIcon.asClassName(manageExtensionIcon),
    tooltip: ( localizeWithPath(_moduleId, 31, "Manage Extension")),
};
registerAction2(class extends Action2 {
    constructor() {
        super({
            id: 'workbench.action.generateColorTheme',
            title: ( localize2WithPath(_moduleId, 32, 'Generate Color Theme From Current Settings')),
            category: Categories.Developer,
            f1: true
        });
    }
    run(accessor) {
        const themeService = accessor.get(IWorkbenchThemeService);
        const theme = themeService.getColorTheme();
        const colors = ( (Registry.as(Extensions.ColorContribution))).getColors();
        const colorIds = ( (colors.map(c => c.id))).sort();
        const resultingColors = {};
        const inherited = [];
        for (const colorId of colorIds) {
            const color = theme.getColor(colorId, false);
            if (color) {
                resultingColors[colorId] = Color.Format.CSS.formatHexA(color, true);
            }
            else {
                inherited.push(colorId);
            }
        }
        const nullDefaults = [];
        for (const id of inherited) {
            const color = theme.getColor(id);
            if (color) {
                resultingColors['__' + id] = Color.Format.CSS.formatHexA(color, true);
            }
            else {
                nullDefaults.push(id);
            }
        }
        for (const id of nullDefaults) {
            resultingColors['__' + id] = null;
        }
        let contents = JSON.stringify({
            '$schema': colorThemeSchemaId,
            type: theme.type,
            colors: resultingColors,
            tokenColors: theme.tokenColors.filter(t => !!t.scope)
        }, null, '\t');
        contents = contents.replace(/\"__/g, '//"');
        const editorService = accessor.get(IEditorService);
        return editorService.openEditor({ resource: undefined, contents, languageId: 'jsonc', options: { pinned: true } });
    }
});
const toggleLightDarkThemesCommandId = 'workbench.action.toggleLightDarkThemes';
registerAction2(class extends Action2 {
    constructor() {
        super({
            id: toggleLightDarkThemesCommandId,
            title: ( localize2WithPath(_moduleId, 33, 'Toggle between Light/Dark Themes')),
            category: Categories.Preferences,
            f1: true,
        });
    }
    async run(accessor) {
        const themeService = accessor.get(IWorkbenchThemeService);
        const configurationService = accessor.get(IConfigurationService);
        const notificationService = accessor.get(INotificationService);
        const preferencesService = accessor.get(IPreferencesService);
        if (configurationService.getValue(ThemeSettings.DETECT_COLOR_SCHEME)) {
            const message = ( localizeWithPath(
                _moduleId,
                34,
                "Cannot toggle between light and dark themes when `{0}` is enabled in settings.",
                ThemeSettings.DETECT_COLOR_SCHEME
            ));
            notificationService.prompt(Severity$1.Info, message, [
                {
                    label: ( localizeWithPath(_moduleId, 35, "Open Settings")),
                    run: () => {
                        return preferencesService.openUserSettings({ query: ThemeSettings.DETECT_COLOR_SCHEME });
                    }
                }
            ]);
            return;
        }
        const currentTheme = themeService.getColorTheme();
        let newSettingsId = ThemeSettings.PREFERRED_DARK_THEME;
        switch (currentTheme.type) {
            case ColorScheme.LIGHT:
                newSettingsId = ThemeSettings.PREFERRED_DARK_THEME;
                break;
            case ColorScheme.DARK:
                newSettingsId = ThemeSettings.PREFERRED_LIGHT_THEME;
                break;
            case ColorScheme.HIGH_CONTRAST_LIGHT:
                newSettingsId = ThemeSettings.PREFERRED_HC_DARK_THEME;
                break;
            case ColorScheme.HIGH_CONTRAST_DARK:
                newSettingsId = ThemeSettings.PREFERRED_HC_LIGHT_THEME;
                break;
        }
        const themeSettingId = configurationService.getValue(newSettingsId);
        if (themeSettingId && typeof themeSettingId === 'string') {
            const theme = (await themeService.getColorThemes()).find(t => t.settingsId === themeSettingId);
            if (theme) {
                themeService.setColorTheme(theme.id, 'auto');
            }
        }
    }
});
const browseColorThemesInMarketplaceCommandId = 'workbench.action.browseColorThemesInMarketplace';
registerAction2(class extends Action2 {
    constructor() {
        super({
            id: browseColorThemesInMarketplaceCommandId,
            title: ( localize2WithPath(_moduleId, 36, 'Browse Color Themes in Marketplace')),
            category: Categories.Preferences,
            f1: true,
        });
    }
    async run(accessor) {
        const marketplaceTag = 'category:themes';
        const themeService = accessor.get(IWorkbenchThemeService);
        const extensionGalleryService = accessor.get(IExtensionGalleryService);
        const extensionResourceLoaderService = accessor.get(IExtensionResourceLoaderService);
        const instantiationService = accessor.get(IInstantiationService);
        if (!extensionGalleryService.isEnabled() || !extensionResourceLoaderService.supportsExtensionGalleryResources) {
            return;
        }
        const currentTheme = themeService.getColorTheme();
        const getMarketplaceColorThemes = (publisher, name, version) => themeService.getMarketplaceColorThemes(publisher, name, version);
        let selectThemeTimeout;
        const selectTheme = (theme, applyTheme) => {
            if (selectThemeTimeout) {
                clearTimeout(selectThemeTimeout);
            }
            selectThemeTimeout = mainWindow.setTimeout(() => {
                selectThemeTimeout = undefined;
                const newTheme = (theme ?? currentTheme);
                themeService.setColorTheme(newTheme, applyTheme ? 'auto' : 'preview').then(undefined, err => {
                    onUnexpectedError(err);
                    themeService.setColorTheme(currentTheme, undefined);
                });
            }, applyTheme ? 0 : 200);
        };
        const marketplaceThemePicker = instantiationService.createInstance(MarketplaceThemesPicker, getMarketplaceColorThemes, marketplaceTag);
        await marketplaceThemePicker.openQuickPick('', themeService.getColorTheme(), selectTheme).then(undefined, onUnexpectedError);
    }
});
const ThemesSubMenu = ( (new MenuId('ThemesSubMenu')));
MenuRegistry.appendMenuItem(MenuId.GlobalActivity, {
    title: ( localizeWithPath(_moduleId, 37, "Themes")),
    submenu: ThemesSubMenu,
    group: '2_configuration',
    order: 7
});
MenuRegistry.appendMenuItem(MenuId.MenubarPreferencesMenu, {
    title: ( localizeWithPath(_moduleId, 38, "&&Theme")),
    submenu: ThemesSubMenu,
    group: '2_configuration',
    order: 7
});
MenuRegistry.appendMenuItem(ThemesSubMenu, {
    command: {
        id: SelectColorThemeCommandId,
        title: ( localizeWithPath(_moduleId, 6, 'Color Theme'))
    },
    order: 1
});
MenuRegistry.appendMenuItem(ThemesSubMenu, {
    command: {
        id: SelectFileIconThemeCommandId,
        title: ( localizeWithPath(_moduleId, 39, "File Icon Theme"))
    },
    order: 2
});
MenuRegistry.appendMenuItem(ThemesSubMenu, {
    command: {
        id: SelectProductIconThemeCommandId,
        title: ( localizeWithPath(_moduleId, 40, "Product Icon Theme"))
    },
    order: 3
});
let DefaultThemeUpdatedNotificationContribution = class DefaultThemeUpdatedNotificationContribution {
    static { DefaultThemeUpdatedNotificationContribution_1 = this; }
    static { this.STORAGE_KEY = 'themeUpdatedNotificationShown'; }
    constructor(_notificationService, _workbenchThemeService, _storageService, _commandService, _telemetryService, _hostService) {
        this._notificationService = _notificationService;
        this._workbenchThemeService = _workbenchThemeService;
        this._storageService = _storageService;
        this._commandService = _commandService;
        this._telemetryService = _telemetryService;
        this._hostService = _hostService;
        if (_storageService.getBoolean(DefaultThemeUpdatedNotificationContribution_1.STORAGE_KEY, -1 )) {
            return;
        }
        setTimeout(async () => {
            if (_storageService.getBoolean(DefaultThemeUpdatedNotificationContribution_1.STORAGE_KEY, -1 )) {
                return;
            }
            if (await this._hostService.hadLastFocus()) {
                this._storageService.store(DefaultThemeUpdatedNotificationContribution_1.STORAGE_KEY, true, -1 , 0 );
                if (this._workbenchThemeService.hasUpdatedDefaultThemes()) {
                    this._showYouGotMigratedNotification();
                }
                else {
                    const currentTheme = this._workbenchThemeService.getColorTheme().settingsId;
                    if (currentTheme === ThemeSettingDefaults.COLOR_THEME_LIGHT_OLD || currentTheme === ThemeSettingDefaults.COLOR_THEME_DARK_OLD) {
                        this._tryNewThemeNotification();
                    }
                }
            }
        }, 3000);
    }
    async _showYouGotMigratedNotification() {
        const usingLight = this._workbenchThemeService.getColorTheme().type === ColorScheme.LIGHT;
        const newThemeSettingsId = usingLight ? ThemeSettingDefaults.COLOR_THEME_LIGHT : ThemeSettingDefaults.COLOR_THEME_DARK;
        const newTheme = (await this._workbenchThemeService.getColorThemes()).find(theme => theme.settingsId === newThemeSettingsId);
        if (newTheme) {
            const choices = [
                {
                    label: ( localizeWithPath(_moduleId, 41, "Keep New Theme")),
                    run: () => {
                        this._writeTelemetry('keepNew');
                    }
                },
                {
                    label: ( localizeWithPath(_moduleId, 42, "Browse Themes")),
                    run: () => {
                        this._writeTelemetry('browse');
                        this._commandService.executeCommand(SelectColorThemeCommandId);
                    }
                },
                {
                    label: ( localizeWithPath(_moduleId, 43, "Revert")),
                    run: async () => {
                        this._writeTelemetry('keepOld');
                        const oldSettingsId = usingLight ? ThemeSettingDefaults.COLOR_THEME_LIGHT_OLD : ThemeSettingDefaults.COLOR_THEME_DARK_OLD;
                        const oldTheme = (await this._workbenchThemeService.getColorThemes()).find(theme => theme.settingsId === oldSettingsId);
                        if (oldTheme) {
                            this._workbenchThemeService.setColorTheme(oldTheme, 'auto');
                        }
                    }
                }
            ];
            await this._notificationService.prompt(Severity$1.Info, ( localizeWithPath(
                _moduleId,
                44,
                "Visual Studio Code now ships with a new default theme '{0}'. If you prefer, you can switch back to the old theme or try one of the many other color themes available.",
                newTheme.label
            )), choices, {
                onCancel: () => this._writeTelemetry('cancel')
            });
        }
    }
    async _tryNewThemeNotification() {
        const newThemeSettingsId = this._workbenchThemeService.getColorTheme().type === ColorScheme.LIGHT ? ThemeSettingDefaults.COLOR_THEME_LIGHT : ThemeSettingDefaults.COLOR_THEME_DARK;
        const theme = (await this._workbenchThemeService.getColorThemes()).find(theme => theme.settingsId === newThemeSettingsId);
        if (theme) {
            const choices = [{
                    label: ( localizeWithPath(_moduleId, 45, "Try New Theme")),
                    run: () => {
                        this._writeTelemetry('tryNew');
                        this._workbenchThemeService.setColorTheme(theme, 'auto');
                    }
                },
                {
                    label: ( localizeWithPath(_moduleId, 46, "Cancel")),
                    run: () => {
                        this._writeTelemetry('cancel');
                    }
                }];
            await this._notificationService.prompt(Severity$1.Info, ( localizeWithPath(
                _moduleId,
                47,
                "Visual Studio Code now ships with a new default theme '{0}'. Do you want to give it a try?",
                theme.label
            )), choices, { onCancel: () => this._writeTelemetry('cancel') });
        }
    }
    _writeTelemetry(outcome) {
        this._telemetryService.publicLog2('themeUpdatedNotication', {
            web: isWeb,
            reaction: outcome
        });
    }
};
DefaultThemeUpdatedNotificationContribution = DefaultThemeUpdatedNotificationContribution_1 = ( (__decorate([
    ( (__param(0, INotificationService))),
    ( (__param(1, IWorkbenchThemeService))),
    ( (__param(2, IStorageService))),
    ( (__param(3, ICommandService))),
    ( (__param(4, ITelemetryService))),
    ( (__param(5, IHostService)))
], DefaultThemeUpdatedNotificationContribution)));
const workbenchRegistry = ( (Registry.as(Extensions$1.Workbench)));
workbenchRegistry.registerWorkbenchContribution(DefaultThemeUpdatedNotificationContribution, 4 );

export { manageExtensionIcon };
